import React from 'react';
import useCart from '../hooks/useCart';
import { useTranslation, Trans } from 'react-i18next';

const ProductModal = ({ product, onClose,showToast }) => {
    const { t } = useTranslation();
    const { increment } = useCart();

    if (!product) return null;

    const discountedPrice = product.discount > 0
        ? product.price - (product.price * product.discount) / 100
        : product.price;

    const handleAddToCart = () => {
        const actualPrice = product.discount > 0
            ? product.price - (product.price * product.discount) / 100
            : product.price;

        increment(product.id, actualPrice, showToast);
    };
    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered container">
                <div className="modal-content bg-light-color border-0">
                    <div className="present-product position-relative d-flex flex-column flex-md-row gap-3 p-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="present-close-btn position-absolute top-0 end-0 m-3"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon icon-tabler icon-tabler-x"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="#6f32be"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="left-present col-md-6">
                            <div className="mb-3">
                                <img
                                    src={`https://akadgatepharmacy.com/backend/storage/app/public${product.featuredImage.replace("/storage",'')}`}
                                    alt={product.name}
                                    className="img-fluid shadow-sm w-100"
                                />
                            </div>
                            {product.secondaryImage && (
                                <div>
                                    <img
                                        src={`https://akadgatepharmacy.com/backend/storage/app/public${product.secondaryImage.replace("/storage",'')}`}
                                        alt={product.name}
                                        className="img-fluid shadow-sm w-100"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="right-present col-md-6 d-flex flex-column justify-content-between gap-3">
                            <div>
                                <h4 className="mb-0 text-color-bright text-center text-md-start">
                                    {product.name}
                                </h4>
                                <h6 className="text-main-muted fw-bold text-center text-md-start">
                                    {discountedPrice.toLocaleString()} IQD
                                </h6>
                                <p>{product.description}</p>

                                <div className="present-details d-flex align-items-center gap-2 mb-2">
                  <span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-truck-delivery"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="#6f32be"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5" />
                      <path d="M3 9l4 0" />
                    </svg>
                  </span>
                                    <span className="text-present-details fs-6 fw-normal">
                    free delivery for orders less than 20,000 IQD
                  </span>
                                </div>

                                <div className="present-details d-flex align-items-center gap-2 mb-2">
                  <span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-cash-banknote"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="#6f32be"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                      <path d="M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
                      <path d="M18 12l.01 0" />
                      <path d="M6 12l.01 0" />
                    </svg>
                  </span>
                                    <span className="text-present-details fs-6 fw-normal">
                    returns are free within 3 days
                  </span>
                                </div>

                                <div className="present-details d-flex align-items-center gap-2">
                                    {product.availability ? (
                                        <>
                      <span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-circle-check"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="#6f32be"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                          <path d="M9 12l2 2l4 -4" />
                        </svg>
                      </span>
                                            <span className="text-present-details fs-6 fw-normal">{t('available in stock')}</span>
                                        </>
                                    ) : (
                                        <>
                      <span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-circle-x"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="#6f32be"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                          <path d="M10 10l4 4m0 -4l-4 4" />
                        </svg>
                      </span>
                                            <span className="text-present-details fs-6 fw-normal">{t('not available in stock')}</span>
                                        </>
                                    )}
                                </div>
                            </div>

                            <button
                                onClick={handleAddToCart}
                                className="present-add-btn btn"
                                disabled={!product.availability}
                            >
                                {t('Add To Cart')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductModal;